import { TripPrice } from '../../lib/types/models/trip-price/trip-price'
import { TripPriceInput } from '../../lib/types/models/trip-price/trip-price-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createTripPrice(data: TripPriceInput & { tripId: number }) {
  const { tripId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.trips.createTripPrice.url, { id: tripId }))
    .post<TripPrice, TripPriceInput>(rest)
}
